function Parts() {
  return (
    <>Parts</>
  );
}

export default Parts;
